import { render, staticRenderFns } from "./LayoutBox.vue?vue&type=template&id=5c019130&scoped=true&"
var script = {}
import style0 from "./LayoutBox.vue?vue&type=style&index=0&id=5c019130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c019130",
  null
  
)

export default component.exports